// Import model
import { CreateSettingsRequest } from '../models/CreateSettingsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateSettingsRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateSettingsRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateSettingsRequest instance
   */
  static deserialize(json: string): CreateSettingsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateSettingsRequest instance
   */
  static fromObject(obj: any): CreateSettingsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateSettingsRequest');
    }


    const instance: CreateSettingsRequest = {
      clientId: obj['clientId'] as string,
      entityId: obj['entityId'] as string | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      directionsProvider: obj['directionsProvider'] as string | undefined,
      phoneCallProvider: obj['phoneCallProvider'] as string | undefined,
      smsProvider: obj['smsProvider'] as string | undefined,
      theme: obj['theme'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateSettingsRequest instances
   */
  static deserializeArray(json: string): CreateSettingsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateSettingsRequest instance to a JSON string
   */
  static serialize(instance: CreateSettingsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateSettingsRequest instance to a plain object
   */
  static toObject(instance: CreateSettingsRequest): any {
    return {
      'clientId': instance.clientId,
      'entityId': instance.entityId,
      'name': instance.name,
      'description': instance.description,
      'directionsProvider': instance.directionsProvider,
      'phoneCallProvider': instance.phoneCallProvider,
      'smsProvider': instance.smsProvider,
      'theme': instance.theme,
    };
  }

  /**
   * Serializes an array of CreateSettingsRequest instances to a JSON string
   */
  static serializeArray(instances: CreateSettingsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
